<div class="d-flex flex-auto flex-column" *ngIf="canShowChart">
  <div class="item line-item" *ngFor="let item of series; let i = index;">
    <div class="d-flex flex-row mention-box">
      <div *ngIf="showIndex" class="index">{{i + 1 + startIndex}}.</div>
      <div class="ellipsis mention {{chartTitleClasses}}">{{item.title}}</div>
    </div>
    <div class="d-flex flex-row mention-percent align-items-center" *ngIf="!isLeftSide">
      <div class="d-flex progress-bar-container right bar-container">
        <div class="progress-bar"
             [style.width.%]="calculateProgress(item.value)"
             [style.backgroundColor]="chartColor"
             [style.height.px]="progressHeight"
             [style.borderRadius.px]="borderRadius">
        </div>
      </div>
      <div *ngIf="!showValue" class="d-flex justify-content-end number">{{calculateProgress(item.value) | percentNumberSuffix}}</div>
      <div *ngIf="showValue" class="d-flex justify-content-end number">{{item.formattedValue}}</div>
    </div>
    <div class="d-flex flex-row mention-percent align-items-center" *ngIf="isLeftSide">
      <div class="d-flex justify-content-end left-number" *ngIf="!hideRelativeCalculation">{{calculateProgress(item.value) | percentNumberSuffix}}</div>
      <div class="d-flex progress-bar-container left bar-container">
        <div class="progress-bar" [style.height.px]="progressHeight"
             [style.borderRadius.px]="borderRadius"
             [style.width.%]="calculateProgress(item.value)"
             [style.backgroundColor]="chartColor"></div>
      </div>
      <div *ngIf="showValue" class="d-flex justify-content-end number">{{item.formattedValue}}</div>
    </div>
  </div>
</div>
<div class="d-flex flex-auto flex-column" *ngIf="!canShowChart">
  <achoo-bar-chart-placeholder [isLeftSide]="isLeftSide"
                               [startIndex]="startIndex"
                               [showIndex]="showIndex"
                               [isLarge]="!isNormalLine"
                               [keywords]="placeholderKeywords">
  </achoo-bar-chart-placeholder>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-bar-chart/achoo-bar-chart.component.html